import React, { useState, useEffect } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';

const DateSelectorModal = ({ show, onClose, onConfirm, onDateChange }) => {
  const [rows, setRows] = useState([{ id: Date.now(), date: '' }]);

  // Reset rows whenever the modal is shown
  useEffect(() => {
    if (show) {
      setRows([{ id: Date.now(), date: '' }]);
    }
  }, [show]);

  const handleAddRow = () => {
    if (rows.length < 2) {
      setRows([...rows, { id: Date.now(), date: '' }]);
    }
  };

  const handleConfirm = () => {
    const uniqueDates = [...new Set(rows.map((row) => row.date).filter(Boolean))];
    onConfirm(uniqueDates);
  };

  const handleDeleteRow = (id) => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleDateChange = (id, value) => {
    if (new Date(value) > new Date()) return; // Prevent future dates

    const updatedRows = rows.map((row) =>
      row.id === id ? { ...row, date: value } : row
    );

    // Ensure only unique dates are added
    const uniqueDates = updatedRows.filter(
      (row, index, self) =>
        row.date === '' || self.findIndex((r) => r.date === row.date) === index
    );

    setRows(uniqueDates);
    onDateChange(uniqueDates.map((row) => row.date));
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Select Date</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table bordered hover>
          <tbody>
            {rows.map((row, index) => (
              <tr key={row.id}>
                <td>
                  <input
                    type="date"
                    value={row.date}
                    max={new Date().toISOString().split('T')[0]} // Restrict to today or earlier
                    onChange={(e) => handleDateChange(row.id, e.target.value)}
                  />
                </td>
                <td>
                  <Button
                    variant="danger"
                    onClick={() => handleDeleteRow(row.id)}
                    disabled={rows.length === 1}
                  >
                    Delete
                  </Button>
                </td>
                <td>
                  {index === rows.length - 1 && (
                    <Button
                      variant="primary"
                      onClick={handleAddRow}
                      disabled={rows.length >= 2} // Limit to 2 rows
                    >
                      Add Date
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Go Back
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DateSelectorModal;
